import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-radio-input',
    templateUrl: './radio-input.component.html',
    styleUrls: ['./radio-input.component.scss'],
    standalone: false
})
export class RadioInputComponent extends BaseFormInput {
}
